// 商品图片上传接口 POST /product/uploadImage
import request from '../requestPB'
import { SERVER_DOMAIN, PROTO_MODULE } from '../constant'

export const uploadImage = ({ imgB64 }) => {
  return request({
    url: `${SERVER_DOMAIN}/product/uploadImage`,
    method: 'POST',
    data: { imgB64 }
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSProductImageUploadRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSProductImageUploadResponse',
    ERROR_ACTION: 'toast',
  })
}
